import { __assign } from "tslib";
import React, { Fragment } from 'react';
import { IconSVG } from '../icon-svg/icon-svg';
export var IconArrowUp = function (SVGprops) {
    return (React.createElement(IconSVG, __assign({}, SVGprops),
        React.createElement(Fragment, null,
            React.createElement("path", { d: "M17.71 8.28984L12 2.58984L6.29004 8.28984L7.71004 9.70984L11 6.40984V19.9998H13V6.40984L16.29 9.70984L17.71 8.28984Z" }))));
};
